import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  List,
  Collapse,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RedeemIcon from "@mui/icons-material/Redeem";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import InboxIcon from "@mui/icons-material/Inbox";

export default function MainListItems() {
  const [open, setOpen] = useState(true);
  const [openNotification, setOpenNotification] = useState(true);
  const location = useLocation();

  const handleClick = () => {
    setOpen(!open);
  };

  const handleNotificationClick = () => {
    setOpenNotification(!openNotification);
  };

  return (
    <React.Fragment>
      <ListItemButton
        component={Link}
        to="/admin/dashboard"
        selected={location.pathname === "/admin/dashboard"}
      >
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
      {/* <ListItemButton>
            <ListItemIcon>
                <ShoppingCartIcon />
            </ListItemIcon>
            <ListItemText primary="Orders" />
        </ListItemButton> */}
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary="Users" />
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/users/administrator"
            selected={location.pathname.startsWith(
              "/admin/users/administrator",
            )}
          >
            <ListItemText primary="Administrator" />
          </ListItemButton>
        </List>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/users/scanner"
            selected={location.pathname.startsWith("/admin/users/scanner")}
          >
            <ListItemText primary="Scanner" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton
        component={Link}
        to="/admin/loyalty"
        selected={location.pathname.startsWith("/admin/loyalty")}
      >
        <ListItemIcon>
          <RedeemIcon />
        </ListItemIcon>
        <ListItemText primary="Loyalty" />
      </ListItemButton>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          <InboxIcon />
        </ListItemIcon>
        <ListItemText primary="Manage ZNS" />
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/outbound-message/overview"
            selected={location.pathname.startsWith(
              "/admin/outbound-message/overview",
            )}
          >
            <ListItemText primary="Overview" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/outbound-message/fetch-message-template"
            selected={location.pathname.startsWith(
              "/admin/outbound-message/fetch-message-template",
            )}
          >
            <ListItemText primary="List of ZNS Template" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/outbound-message/manual-send"
            selected={location.pathname.startsWith(
              "/admin/outbound-message/manual-send",
            )}
          >
            <ListItemText primary="Manual Send" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/outbound-message/auto-sending"
            selected={location.pathname.startsWith(
              "/admin/outbound-message/auto-sending",
            )}
          >
            <ListItemText primary="Automatic Send" />
          </ListItemButton>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/outbound-message/auto-report"
            selected={location.pathname.startsWith(
              "/admin/outbound-message/auto-report",
            )}
          >
            <ListItemText primary="Auto Sending Report" />
          </ListItemButton>
        </List>
      </Collapse>
      <ListItemButton
        // component={Link}
        // to="/admin/notification"
        // selected={location.pathname.startsWith("/admin/notification")}\
        onClick={handleNotificationClick}
      >
        <ListItemIcon>
          <NotificationsNoneIcon />
        </ListItemIcon>
        <ListItemText primary="Notification" />
        {openNotification ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>
      <Collapse in={openNotification} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/notification/error"
            selected={location.pathname.startsWith("/admin/notification/error")}
          >
            <ListItemText primary="Error List" />
          </ListItemButton>
        </List>
        <List component="div" disablePadding>
          <ListItemButton
            sx={{ pl: 9 }}
            component={Link}
            to="/admin/notification/history"
            selected={location.pathname.startsWith(
              "/admin/notification/history",
            )}
          >
            <ListItemText primary="History" />
          </ListItemButton>
        </List>
      </Collapse>
      {/* <ListItemButton component={Link} to="/admin/events">
                <ListItemIcon>
                    <EventIcon />
                </ListItemIcon>
                <ListItemText primary="Events" />
            </ListItemButton> */}
      {/* <ListItemButton>
            <ListItemIcon>
                <LayersIcon />
            </ListItemIcon>
            <ListItemText primary="Integrations" />
        </ListItemButton> */}
    </React.Fragment>
  );
}

export const secondaryListItems = (
  <React.Fragment>
    <ListSubheader component="div" inset>
      Saved reports
    </ListSubheader>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Current month" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Last quarter" />
    </ListItemButton>
    <ListItemButton>
      <ListItemIcon>
        <AssignmentIcon />
      </ListItemIcon>
      <ListItemText primary="Year-end sale" />
    </ListItemButton>
  </React.Fragment>
);
